"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_ga4_1 = __importDefault(require("react-ga4"));

var accountId = process.env.REACT_APP_GA_ID;

var GoogleAnalyticsProvider =
/** @class */
function () {
  function GoogleAnalyticsProvider() {
    this.initialize();
  }

  GoogleAnalyticsProvider.getInstance = function () {
    if (!GoogleAnalyticsProvider.instance) {
      GoogleAnalyticsProvider.instance = new GoogleAnalyticsProvider();
    }

    return GoogleAnalyticsProvider.instance;
  };

  GoogleAnalyticsProvider.prototype.setPersonId = function (personId) {
    react_ga4_1.default.set({
      dimension1: personId
    });
  };

  GoogleAnalyticsProvider.prototype.setOrigAccessCode = function (origAccessCode) {
    react_ga4_1.default.set({
      dimension2: origAccessCode
    });
  };

  GoogleAnalyticsProvider.prototype.initialize = function () {
    react_ga4_1.default.initialize(accountId);
  };

  GoogleAnalyticsProvider.prototype.recordView = function (location) {
    react_ga4_1.default.send({
      hitType: 'pageview',
      page: location
    });
  };

  return GoogleAnalyticsProvider;
}();

exports.GoogleAnalyticsProvider = GoogleAnalyticsProvider;
exports.googleAnalyticsProvider = GoogleAnalyticsProvider.getInstance();